export default {"src":"/_next/static/media/NOC.f4016fd5.svg","height":18,"width":18};